module.exports = "/images/water-park.svg?9924da3943b903815463df5eea3cda2e";